module.exports = __webpack_public_path__ + "static/media/ManjimupBridgetownTimes-devicecomp-min.df525087.webp";